/* import __COLOCATED_TEMPLATE__ from './period-chooser-header.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import discourseComputed from "discourse/lib/decorators";
import DropdownSelectBoxHeaderComponent from "select-kit/components/dropdown-select-box/dropdown-select-box-header";
const PeriodChooserHeader = dt7948.c(class PeriodChooserHeader extends DropdownSelectBoxHeaderComponent {
  caretIcon(isExpanded) {
    return isExpanded ? "caret-up" : "caret-down";
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [discourseComputed("selectKit.isExpanded")]);
  }
}, [classNames("period-chooser-header", "btn-flat")]);
export default PeriodChooserHeader;